import VirtualizedTableRenderer from "./VirtualizedTableRenderer.js";
import BasicTableRenderer from "./BasicTableRenderer.js";
export { default as BasicRowRenderer } from "./row/BasicRowRenderer.js";
export { default as VirtualizedRowRenderer } from "./row/VirtualizedRowRenderer.js";
export const TABLE_TYPES = {
  basic: BasicTableRenderer,
  virtualized: VirtualizedTableRenderer
};